'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.YoutubeVideo = exports.TwitterShare = exports.TermsOfService = exports.SocialLinks = exports.Social = exports.Recipe = exports.ProductSlide = exports.ProductsGallery = exports.ProductsCarousel = exports.ProductCard = exports.PrivacyPolicy = exports.Print = exports.PrevButton = exports.PinterestShare = exports.NutritionFacts = exports.NextButton = exports.NavItem = exports.Nav = exports.Modal = exports.Logo = exports.List = exports.HtmlVideo = exports.Hero = exports.Header = exports.Grid = exports.Footer = exports.FilterText = exports.FilterResetButton = exports.FilterDropdown = exports.FilterDebug = exports.FilterButton = exports.Filter = exports.FacebookShare = exports.EmailShare = exports.Collapse = exports.CirclingCarousel = exports.CarouselDots = exports.Carousel = exports.BazaarVoiceModal = exports.BazaarVoiceInlineWrapper = exports.BazaarVoiceInline = exports.BazaarVoice = exports.Agegate = undefined;
var _Agegate = require('./js/components/agegate/Agegate');
var _Agegate2 = _interopRequireDefault(_Agegate);
var _BazaarVoice = require('./js/components/bazaarvoice/BazaarVoice');
var _BazaarVoice2 = _interopRequireDefault(_BazaarVoice);
var _BazaarVoiceInline = require('./js/components/bazaarvoice/BazaarVoiceInline');
var _BazaarVoiceInline2 = _interopRequireDefault(_BazaarVoiceInline);
var _BazaarVoiceInlineWrapper = require('./js/components/bazaarvoice/BazaarVoiceInlineWrapper');
var _BazaarVoiceInlineWrapper2 = _interopRequireDefault(_BazaarVoiceInlineWrapper);
var _BazaarVoiceModal = require('./js/components/bazaarvoice/BazaarVoiceModal');
var _BazaarVoiceModal2 = _interopRequireDefault(_BazaarVoiceModal);
var _Carousel = require('./js/components/carousel/Carousel');
var _Carousel2 = _interopRequireDefault(_Carousel);
var _CarouselDots = require('./js/components/carousel/CarouselDots');
var _CarouselDots2 = _interopRequireDefault(_CarouselDots);
var _CirclingCarousel = require('./js/components/carousel/CirclingCarousel');
var _CirclingCarousel2 = _interopRequireDefault(_CirclingCarousel);
var _Collapse = require('./js/components/collapse/Collapse');
var _Collapse2 = _interopRequireDefault(_Collapse);
var _EmailShare = require('./js/components/social/EmailShare');
var _EmailShare2 = _interopRequireDefault(_EmailShare);
var _FacebookShare = require('./js/components/social/FacebookShare');
var _FacebookShare2 = _interopRequireDefault(_FacebookShare);
var _Footer = require('./js/components/footer/Footer');
var _Footer2 = _interopRequireDefault(_Footer);
var _Filter = require('./js/components/filter/Filter');
var _Filter2 = _interopRequireDefault(_Filter);
var _FilterButton = require('./js/components/filter/FilterButton');
var _FilterButton2 = _interopRequireDefault(_FilterButton);
var _FilterDebug = require('./js/components/filter/FilterDebug');
var _FilterDebug2 = _interopRequireDefault(_FilterDebug);
var _FilterDropdown = require('./js/components/filter/FilterDropdown');
var _FilterDropdown2 = _interopRequireDefault(_FilterDropdown);
var _FilterResetButton = require('./js/components/filter/FilterResetButton');
var _FilterResetButton2 = _interopRequireDefault(_FilterResetButton);
var _FilterText = require('./js/components/filter/FilterText');
var _FilterText2 = _interopRequireDefault(_FilterText);
var _Grid = require('./js/components/grid/Grid');
var _Grid2 = _interopRequireDefault(_Grid);
var _Hero = require('./js/components/hero/Hero');
var _Hero2 = _interopRequireDefault(_Hero);
var _HtmlVideo = require('./js/components/video/HtmlVideo');
var _HtmlVideo2 = _interopRequireDefault(_HtmlVideo);
var _Header = require('./js/components/header/Header');
var _Header2 = _interopRequireDefault(_Header);
var _List = require('./js/components/list/List');
var _List2 = _interopRequireDefault(_List);
var _Logo = require('./js/components/header/Logo');
var _Logo2 = _interopRequireDefault(_Logo);
var _Modal = require('./js/components/modal/Modal');
var _Modal2 = _interopRequireDefault(_Modal);
var _Nav = require('./js/components/header/Nav');
var _Nav2 = _interopRequireDefault(_Nav);
var _NavItem = require('./js/components/header/NavItem');
var _NavItem2 = _interopRequireDefault(_NavItem);
var _NextButton = require('./js/components/buttons/NextButton');
var _NextButton2 = _interopRequireDefault(_NextButton);
var _NutritionFacts = require('./js/components/nutrition/NutritionFacts');
var _NutritionFacts2 = _interopRequireDefault(_NutritionFacts);
var _PinterestShare = require('./js/components/social/PinterestShare');
var _PinterestShare2 = _interopRequireDefault(_PinterestShare);
var _PrevButton = require('./js/components/buttons/PrevButton');
var _PrevButton2 = _interopRequireDefault(_PrevButton);
var _Print = require('./js/components/social/Print');
var _Print2 = _interopRequireDefault(_Print);
var _PrivacyPolicy = require('./js/components/privacypolicy/PrivacyPolicy');
var _PrivacyPolicy2 = _interopRequireDefault(_PrivacyPolicy);
var _ProductCard = require('./js/components/productCard/ProductCard');
var _ProductCard2 = _interopRequireDefault(_ProductCard);
var _ProductsCarousel = require('./js/components/carousel/ProductsCarousel');
var _ProductsCarousel2 = _interopRequireDefault(_ProductsCarousel);
var _ProductsGallery = require('./js/components/productsGallery/ProductsGallery');
var _ProductsGallery2 = _interopRequireDefault(_ProductsGallery);
var _ProductSlide = require('./js/components/carousel/ProductSlide');
var _ProductSlide2 = _interopRequireDefault(_ProductSlide);
var _Recipe = require('./js/components/recipe/Recipe');
var _Recipe2 = _interopRequireDefault(_Recipe);
var _Social = require('./js/components/social/Social');
var _Social2 = _interopRequireDefault(_Social);
var _SocialLinks = require('./js/components/social/SocialLinks');
var _SocialLinks2 = _interopRequireDefault(_SocialLinks);
var _TermsOfService = require('./js/components/termsofservice/TermsOfService');
var _TermsOfService2 = _interopRequireDefault(_TermsOfService);
var _TwitterShare = require('./js/components/social/TwitterShare');
var _TwitterShare2 = _interopRequireDefault(_TwitterShare);
var _YoutubeVideo = require('./js/components/video/YoutubeVideo');
var _YoutubeVideo2 = _interopRequireDefault(_YoutubeVideo);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

/* mock browser objects for server-side rendering */
if (typeof window === 'undefined') {
  var dummyElement = {
    style: {},
    appendChild: function appendChild() {},
    removeChild: function removeChild() {}
  };
  global.window = {
    location: {}
  };
  global.navigator = {
    userAgent: ''
  };
  global.document = {
    createElement: function createElement() {
      return dummyElement;
    }
  };
}
exports.Agegate = _Agegate2.default;
exports.BazaarVoice = _BazaarVoice2.default;
exports.BazaarVoiceInline = _BazaarVoiceInline2.default;
exports.BazaarVoiceInlineWrapper = _BazaarVoiceInlineWrapper2.default;
exports.BazaarVoiceModal = _BazaarVoiceModal2.default;
exports.Carousel = _Carousel2.default;
exports.CarouselDots = _CarouselDots2.default;
exports.CirclingCarousel = _CirclingCarousel2.default;
exports.Collapse = _Collapse2.default;
exports.EmailShare = _EmailShare2.default;
exports.FacebookShare = _FacebookShare2.default;
exports.Filter = _Filter2.default;
exports.FilterButton = _FilterButton2.default;
exports.FilterDebug = _FilterDebug2.default;
exports.FilterDropdown = _FilterDropdown2.default;
exports.FilterResetButton = _FilterResetButton2.default;
exports.FilterText = _FilterText2.default;
exports.Footer = _Footer2.default;
exports.Grid = _Grid2.default;
exports.Header = _Header2.default;
exports.Hero = _Hero2.default;
exports.HtmlVideo = _HtmlVideo2.default;
exports.List = _List2.default;
exports.Logo = _Logo2.default;
exports.Modal = _Modal2.default;
exports.Nav = _Nav2.default;
exports.NavItem = _NavItem2.default;
exports.NextButton = _NextButton2.default;
exports.NutritionFacts = _NutritionFacts2.default;
exports.PinterestShare = _PinterestShare2.default;
exports.PrevButton = _PrevButton2.default;
exports.Print = _Print2.default;
exports.PrivacyPolicy = _PrivacyPolicy2.default;
exports.ProductCard = _ProductCard2.default;
exports.ProductsCarousel = _ProductsCarousel2.default;
exports.ProductsGallery = _ProductsGallery2.default;
exports.ProductSlide = _ProductSlide2.default;
exports.Recipe = _Recipe2.default;
exports.Social = _Social2.default;
exports.SocialLinks = _SocialLinks2.default;
exports.TermsOfService = _TermsOfService2.default;
exports.TwitterShare = _TwitterShare2.default;
exports.YoutubeVideo = _YoutubeVideo2.default;